import { defineMessages } from 'react-intl';

export const DestinationMessages = defineMessages({
  domestic: {
    description: 'filterOptions.destinationDomestic',
    defaultMessage: 'Domestic',
    id: 'y9VJCS',
  },
  international: {
    description: 'filterOptions.destinationInternational',
    defaultMessage: 'International',
    id: '94roj/',
  },
});

export const EmailSentMessages = defineMessages({
  sent: {
    description: 'filterOptions.emailSent',
    defaultMessage: 'Sent',
    id: '30Ksoy',
  },
  notSent: {
    description: 'filterOptions.emailNotSent',
    defaultMessage: 'Not Sent',
    id: 'vbMayF',
  },
  error: {
    description: 'filterOptions.emailFailed',
    defaultMessage: 'Failed',
    id: 'xdrOTc',
  },
});

export const NotificationSentMessages = defineMessages({
  notified: {
    description: 'filterOptions.notificationSent',
    defaultMessage: 'Notified',
    id: 'hjKNz7',
  },
  notNotified: {
    description: 'filterOptions.notificationNotSent',
    defaultMessage: 'Not Notified',
    id: '1Xw+aL',
  },
  error: {
    description: 'filterOptions.notificationFailed',
    defaultMessage: 'Failed',
    id: 'OczlkL',
  },
});

export const LabelPrintedMessages = defineMessages({
  printed: {
    description: 'filterOptions.labelPrinted',
    defaultMessage: 'Printed',
    id: 'CI9dYY',
  },
  notPrinted: {
    description: 'filterOptions.labelNotPrinted',
    defaultMessage: 'Not Printed',
    id: 'Iea+MZ',
  },
});

export const PackingSlipMessages = defineMessages({
  printed: {
    description: 'filterOptions.labelPrinted',
    defaultMessage: 'Printed',
    id: 'CI9dYY',
  },
  notPrinted: {
    description: 'filterOptions.labelNotPrinted',
    defaultMessage: 'Not Printed',
    id: 'Iea+MZ',
  },
});

export const RateMessages = defineMessages({
  hasRate: {
    description: 'filterOptions.hasRate',
    defaultMessage: 'Has Rate',
    id: '0YLgI0',
  },
  doesNotHaveRate: {
    description: 'filterOptions.doesNotHaveRate',
    defaultMessage: 'Does Not Have Rate',
    id: 'G7xog8',
  },
});

export const PendingCustomsDocumentsMessages = defineMessages({
  hasPending: {
    description: 'filterOptions.pendingCustomsDocs.hasPending',
    defaultMessage: 'Has Pending Documents',
    id: 'khnlxE',
  },
  noPending: {
    description: 'filterOptions.pendingCustomsDocs.noPending',
    defaultMessage: 'No Pending Documents',
    id: 'bZoolv',
  },
});
